import * as swcHelpers from '@swc/helpers';
import React__default, { useContext } from 'react';

const DeliveryIndicatorContext = /*#__PURE__*/ React__default.createContext({});
const useDeliveryIndicator = ()=>useContext(DeliveryIndicatorContext)
;
function withDeliveryIndicator(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    const WithDeliveryIndicator = (props)=>{
         return React__default.createElement(DeliveryIndicatorContext.Consumer, null, (context)=>{
             return React__default.createElement(Component, swcHelpers.extends({}, props, {
                config: context === null || context === void 0 ? void 0 : context.config
            }));
        });
    };
    WithDeliveryIndicator.displayName = `WithDeliveryIndicator(${wrappedName})`;
    return WithDeliveryIndicator;
}

export { DeliveryIndicatorContext as default, useDeliveryIndicator, withDeliveryIndicator };
//# sourceMappingURL=context.js.map
